import { getYesOrNoOptions } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { Typography } from 'libs/ui';
import { SettingsContent } from 'modules/administration/common/components';

import { Field } from '../../../forms/onboardingSettingsForm';

export const PersonalAccountSettings = () => {
  const { t } = useTranslation();
  return (
    <SettingsContent
      leftContent={
        <Typography variant="bodyBold">
          {t('administration.onboarding.personalAccount.title')}
        </Typography>
      }
      rightContent={
        <Field.Autocomplete
          fullWidth
          helperTextAbsolute
          showRequiredMark
          label={t(
            'administration.onboarding.personalAccount.personalAccountField.label'
          )}
          name="isAutomaticPersonalAccountGenerationEnabled"
          optionLabelKey="label"
          options={getYesOrNoOptions(t)}
          optionValueKey="value"
          placeholder={t(
            'administration.onboarding.personalAccount.personalAccountField.placeholder'
          )}
          variant="select"
        />
      }
    />
  );
};
